import gql from 'graphql-tag';

export const END_PAGE_MUTATION = gql`
  mutation endTrackPage($contentPageCompletionId: Int!) {
    userFlowStepTrack {
      endContentPageCompletion(trackingId: $contentPageCompletionId, status: COMPLETED) {
        id
      }
    }
  }
`;
